export default function ErrorPage(){
    return(
        <div className="w-full h-screen flex justify-center items-center">
            <p className="text-gray-700 text-[3.2rem] font-bold font-bakbak">404 NOT FOUND</p>
        </div>
    )
}